import { VuexModule, Module, Mutation, Action } from "vuex-class-modules";
import { CategoriesInterface, responseInterface } from "@/types";
import api from "@/apiClient";

@Module
export default class CategoriesModule extends VuexModule {
  private globalLoader = false;
  private categories: CategoriesInterface[] = [];
  private active: CategoriesInterface = { id: "", name: "", title: "" };

  @Action
  public async Load(lang: string): Promise<void> {
    this.setGlobalLoader(true);

    try {
      const response: responseInterface = await api.categories.fetch(lang);

      if (response.statusCode !== 200 || !Array.isArray(response.data)) {
        throw new Error("Data must be an array!");
      }

      const data = response.data as CategoriesInterface[];

      this.setCategories(data);

      if (!this.getActive?.id) {
        this.updateActive(this.getActiveDefault);
      }
    } catch (error) {
      console.error("Error loading categories:", error);
    } finally {
      this.setGlobalLoader(false);
    }
  }

  @Action
  public updateActive(active: CategoriesInterface): void {
    this.setActive(active);
  }

  @Mutation
  private setCategories(categories: CategoriesInterface[]): void {
    this.categories = categories;
  }

  @Mutation
  private setActive(active: CategoriesInterface): void {
    this.active = active;
  }

  @Mutation
  private setGlobalLoader(loader: boolean): void {
    this.globalLoader = loader;
  }

  get getCategories(): CategoriesInterface[] {
    return this.categories.filter((c) => c.visible);
  }

  get getActive(): CategoriesInterface {
    return this.active;
  }

  private get getActiveDefault(): CategoriesInterface {
    return this.getCategories[0];
  }

  get getGlobalLoader(): boolean {
    return this.globalLoader;
  }
}
